import { BatchImport, BatchImportLogStatus } from '@/api'
import DialogUploadValues from '@/types/dialogUploadValues'

export default function buildPendingFolder(
  values: DialogUploadValues,
  batchImportID: string
): BatchImport {
  return {
    fbid: batchImportID,
    createdAt: new Date().toISOString(),
    description: values.recordName,
    metadata: {
      dataSetName: values.recordName,
    },
    batchImportLogStatus: BatchImportLogStatus.Upload,
    groupId: values.group,
    files: values.files.map((file) => ({ name: file.name })),
  }
}
